module.exports = __webpack_public_path__ + "img/social2.b3a8738a.png";